var iframe = $('.video-modal--video');
var player = null;
const close = (e) => {
  if(e.keyCode === 27){
    closeVideoModal();
  }
}

function closeVideoModal(){
    $('body').css('overflow', 'visible');
    $('.video-modal--container').removeClass('active');
    player.pause();
    window.removeEventListener('keydown', close)
}

$('.video-modal--link').on('click', function() {
    window.scrollTo(0,0);
    $('body').css('overflow', 'hidden');

    if( !$(iframe[0]).attr('src') ){
      let videoSrc = iframe.data('src');
      $(iframe[0]).attr('src', videoSrc);
      player = new Vimeo.Player(iframe)
    }

    $('.video-modal--container').addClass('active');
    player.play();

    // Set up event listener to close modal upon Esc keypress
    window.addEventListener('keydown', close)
    $('.video-modal--close').on('click', closeVideoModal);
});